/* eslint-disable */
const crypto = require('crypto')
const toByteArr = (str) => {
  var bytes = []

  for (var i = 0; i < str.length; ++i) {
    bytes.push(str.charCodeAt(i))
  }
  return bytes
}

export const DecryptionText = (text) => {
  if (text !== '') {
    var key = toByteArr('Fs@#dsGERHcx482$')
    var iv = [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
    var decipher = crypto.createDecipheriv('AES-128-CBC', key, iv)
    if (decipher) {
      var text = text.replace(' ', '+')
      var decryptedInput = decipher.update(text, 'base64', 'utf8') + decipher.final('utf8')
      return decryptedInput
    } else {
      return ''
    }
  } else {
    return ''
  }
}
